import { Box, LinearProgress } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  progressPercent: number;
};

export const Progress = ({ progressPercent }: Props) => {
  const { t } = useResource();

  return (
    <Box width="100%" position="absolute" bottom={0}>
      <LinearProgress
        variant="determinate"
        value={progressPercent}
        aria-label={t(Resources.Components.Shared.Progress.AriaLabel, {
          progress: Math.round(progressPercent),
        })}
        sx={({ spacing }) => ({
          height: 5,
          borderRadius: 3,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          backgroundColor: "grey.200",
          "& .MuiLinearProgress-bar": {
            borderRadius: 3,
            borderTopLeftRadius: progressPercent === 100 ? 0 : spacing(3),
            borderTopRightRadius: progressPercent === 100 ? 0 : spacing(3),
            backgroundColor:
              progressPercent === 100 ? "success.main" : "primary.main",
          },
        })}
      />
    </Box>
  );
};
